/**
 * RMKM Phase 2 Changes
 * added by @ali 
 * date : 9 April 2025
 * Fixed the chart & make it dynamic and change it's color
 *  */
import React, { useEffect, useState } from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import inventoryApi from '../../api/inventoryApi';

const PieChart = () => {
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: '# of Votes',
        data: [],
        backgroundColor: [
          '#6096B4',
          '#93BFCF',
          '#BDCDD6',
          '#EEE9DA',
        ],
        borderColor: [
          '#6096B4',
          '#93BFCF',
          '#BDCDD6',
          '#EEE9DA',
        ],
        borderWidth: 1,
      },
    ],
  });

  const fetchData = async () => {
    const result = await inventoryApi.fetchBranchWiseCount();
    console.log('result', result);
    const tempData = {
      labels: result?.rows?.map((data) => data.location) || [],
      datasets: [
        {
          label: '',
          data: result?.rows?.map((data) => data.count) || [],
          backgroundColor:  [
            'rgba(252,76,122,1)','rgba(255,99,71,1)','rgba(160,160,140,1)','rgba(41,187,213,1)','rgba(65,241,99,1)',
            'rgba(70,70,255,1)','rgba(186,104,200,1)','rgba(52,152,219,1)','rgba(230,126,34,1)','rgba(26,188,156,1)',
            'rgba(231,76,60,1)','rgba(142,68,173,1)','rgba(52,73,94,1)','rgba(241,196,15,1)','rgba(255,165,0,1)',
            'rgba(0,191,255,1)','rgba(127,255,0,1)','rgba(255,20,147,1)','rgba(138,43,226,1)','rgba(60,179,113,1)',
            'rgba(255,105,180,1)','rgba(70,130,180,1)','rgba(255,215,0,1)','rgba(100,149,237,1)','rgba(210,105,30,1)'
          ],
          borderColor:   [
            'rgba(252,76,122,1)','rgba(255,99,71,1)','rgba(160,160,140,1)','rgba(41,187,213,1)','rgba(65,241,99,1)',
            'rgba(70,70,255,1)','rgba(186,104,200,1)','rgba(52,152,219,1)','rgba(230,126,34,1)','rgba(26,188,156,1)',
            'rgba(231,76,60,1)','rgba(142,68,173,1)','rgba(52,73,94,1)','rgba(241,196,15,1)','rgba(255,165,0,1)',
            'rgba(0,191,255,1)','rgba(127,255,0,1)','rgba(255,20,147,1)','rgba(138,43,226,1)','rgba(60,179,113,1)',
            'rgba(255,105,180,1)','rgba(70,130,180,1)','rgba(255,215,0,1)','rgba(100,149,237,1)','rgba(210,105,30,1)'
          ],
          // backgroundColor:  //["rgba(255, 215, 0, 1)", "rgba(0, 128, 128, 1)", "rgba(255, 0, 0, 1)", "rgba(100, 216, 255, 1)", "rgba(255, 179, 72, 1)", "rgba(255, 87, 51, 1)", "rgba(142, 68, 173,1)"],
          // borderColor: //["rgba(255, 215, 0, 1)", "rgba(0, 128, 128, 1)", "rgba(255, 0, 0, 1)", "rgba(100, 216, 255, 1)", "rgba(255, 179, 72, 1)", "rgba(255, 87, 51, 1)", "rgba(142, 68, 173,1)"],
          borderWidth: 1,
        },
      ],
    };
    setData(tempData);
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  ChartJS.register(ArcElement, Tooltip, Legend);
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: 'Branch wise performance',
      },
    },
  };

  return (
    <Pie data={data} options={options} />
  )
}

export default PieChart